a.condition = (function(){
	return {}
}());